import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
// import toast from 'react-hot-toast' // Descomentar si usas toast
import { useAuth } from '../context/AuthContext'
import Icon from '../components/atoms/Icon'

const RegisterUser = () => {
  const navigate = useNavigate()
  const { registrarUsuario, loading } = useAuth()

  const { register, handleSubmit, formState: { errors }, setFocus } = useForm({
    defaultValues: {
      nit: '',
      correo: ''
    }
  });

  useEffect(() => { setFocus('nit'); }, [setFocus]);

  const onSubmit = async (data) => {
    const result = await registrarUsuario(data.nit, data.correo)
    if (result.success) {
      navigate('/login')
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-ec-primary-50 via-white to-ec-primary-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-24 w-24 flex items-center justify-center bg-ec-primary-600 rounded-xl shadow-lg">
            <Icon name="user" className="h-12 w-12 text-white" />
          </div>
          <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
            Registro de Usuario
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Complete el registro para acceder al sistema de pagos
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="bg-white p-8 rounded-2xl shadow-xl space-y-6">

            <div>
              <label htmlFor="nit" className="block text-sm font-semibold text-gray-700 mb-2">
                NIT <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                inputMode="numeric"
                placeholder="Ingrese su NIT - Ejemplo: xxx.xxx.xxx-x"
                className={[
                  'w-full h-12 rounded-full',
                  'bg-white/95 border border-gray-300',
                  'px-5 text-gray-800 placeholder-gray-400',
                  'outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-400',
                  errors.nit ? 'border-red-400 focus:ring-red-300 focus:border-red-400' : '',
                ].join(' ')}
                {...register('nit', {
                  required: 'El NIT es obligatorio',
                  pattern: {
                    value: /^[0-9.\-]+$/,
                    message: 'El NIT solo puede contener números, puntos y guiones',
                  },
                  minLength: {
                    value: 6,
                    message: 'El NIT debe tener al menos 6 caracteres',
                  },
                })}
              />
              {errors.nit && (
                <p className="mt-2 text-sm text-red-600">{errors.nit.message}</p>
              )}
            </div>

            <div>
              <label htmlFor="correo" className="block text-sm font-semibold text-gray-700 mb-2">
                Correo Electrónico <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Icon name="mail" className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="correo"
                  type="email"
                  autoComplete="email"
                  className={`block w-full pl-10 pr-3 py-3 border rounded-xl shadow-sm placeholder-gray-400
                    focus:outline-none focus:ring-2 focus:ring-ec-primary-500 focus:border-transparent
                    ${errors.correo ? 'border-red-300' : 'border-gray-300'}`}
                  placeholder="usuario@empresa.com"
                  {...register('correo', {
                    required: 'El correo electrónico es obligatorio',
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: 'El correo electrónico debe ser válido',
                    },
                  })}
                />
              </div>
              {errors.correo && (
                <p className="mt-2 text-sm text-red-600">{errors.correo.message}</p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent
                       text-sm font-medium rounded-xl text-white bg-ec-primary-600 hover:bg-ec-primary-700
                       focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ec-primary-500
                       disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200
                       shadow-lg hover:shadow-xl cursor-pointer"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <Icon
                  name={loading ? "loader" : "user-plus"}
                  className={`h-5 w-5 text-white ${loading ? 'animate-spin' : ''}`}
                />
              </span>
              {loading ? 'Registrando...' : 'Registrar Usuario'}
            </button>
          </div>
        </form>

        <div className="text-center space-y-4">
          <div className="text-sm text-gray-600">
            ¿Ya tiene una cuenta?{' '}
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="font-medium text-ec-primary-600 hover:text-ec-primary-500 transition-colors"
            >
              Iniciar sesión aquí
            </button>
          </div>

          <div className="border-t border-gray-200 pt-4">
            <p className="text-xs text-gray-500">
              Al registrarse, acepta nuestros términos de servicio y política de privacidad.
              Para soporte técnico, contacte a software_ecgroup@eccargosa.com.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegisterUser